module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_mobile_02@2x-0f0773bd711e7cb6750b7f6322165d49.jpg";